import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import React from "react";
import { palette } from "../../../theme/palette";
import clsx from "clsx";

let backgroundColors = {
  blue: palette.btn.blueFill,
  gray: palette.whiteDisabled,
  red: palette.dpdRed,
  yellow: palette.btn.yellowFill,
};

let textColors = {
  yellow: palette.typography.black.solid,
};

const useStyles = makeStyles({
  closeButton: {
    padding: "0 5px 0 5px",
    margin: "0 5px 0 5px",
    fontSize: "10px",
    height: "17px",
    lineHeight: "13px",
    background: (props) =>
      backgroundColors[props.variant] || backgroundColors.gray,
    color: (props) =>
      textColors[props.variant] || palette.typography.white.solid,
  },
  disabled: {
    background: `${palette.typography.white.inactive}!important`,
    color: `${palette.typography.white.medium}!important`,
  },
});

export const ActionButton = ({ children, variant, ...rest }) => {
  const classes = useStyles({ variant });

  return (
    <Button
      className={clsx(classes.closeButton, rest.disabled && classes.disabled)}
      size="small"
      variant="contained"
      {...rest}
    >
      {children}
    </Button>
  );
};
